import React, { ReactChild, useRef } from 'react';
import { makeStyles } from '~/UIKit/Style';
import { USCConnected, USCTransmitting, USCCross } from '~/Components/Icons';

import { PresenceType, BookingStatus } from '~/Models/DTO/Booking.models';
import { useTranslation } from 'react-i18next';
import { TooltipWrapper } from './TooltipWrapper';

export const styles = makeStyles(() => ({
  icon: {
    width: 49,
    height: 49,
    margin: '-20px 0',
  },
}));

export const USCCheckInStatus = ({
  presenceType,
  status,
}: {
  presenceType: PresenceType;
  status: BookingStatus;
}) => {
  const { classes } = styles();
  const containerRef = useRef(null);
  const { t } = useTranslation();

  let USCIcons: ReactChild = <span />;

  if (status === BookingStatus.CANCELLED) {
    return <span />;
  } else {
    switch (presenceType) {
      case PresenceType.PRESENT:
        USCIcons = (
          <TooltipWrapper
            icon={<USCConnected className={classes.icon} />}
            containerRef={containerRef}
            title={t('app.checkin.tooltip.present')}
          />
        );
        break;
      case PresenceType.ABSENT:
        USCIcons = (
          <TooltipWrapper
            icon={<USCCross className={classes.icon} />}
            containerRef={containerRef}
            title={t('app.checkin.tooltip.absent')}
          />
        );
        break;
      case PresenceType.NONE:
        USCIcons = (
          <TooltipWrapper
            icon={<USCTransmitting className={classes.icon} />}
            containerRef={containerRef}
            title={t('app.checkin.tooltip.none')}
          />
        );
        break;
    }
  }

  return USCIcons;
};
